'use client';

import React, { useContext } from 'react';
import { FunnelData } from 'shared-react-components';

const FunnelDataContext = React.createContext<FunnelData | undefined>(undefined)

export interface FunnelDatarProviderProps {
  children: React.ReactNode,
  value?: FunnelData
}

export function FunnelDataProvider({
  children,
  value
}: FunnelDatarProviderProps) {
  return (
    <FunnelDataContext.Provider value={value}>
      {children}
    </FunnelDataContext.Provider>
  );
}

export function useFunnelData() {

  const analyticsContext = useContext(FunnelDataContext);

  if (!analyticsContext) {
    throw new Error('useFunnelData must be used within an <FunnelDataProvider>');
  }

  return analyticsContext;
}
